import debounce from './debounce';

export default function resizeMonitor (callback:Function, wait:number) {
  window.addEventListener('resize', debounce(callback, wait));
}
